import React from 'react';
import Section from '../components/ui/Section';
import Header from './Header';
import Footer from './Footer';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-page">
            <Header variant="marketing" />
            <Section variant="large" className="privacy-policy-section-wrapper">
                <div className="privacy-policy-content">
                    <h1 className="privacy-policy-heading">Privacy Statement for MotionSpace BV</h1>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Introduction</h2>
                        <p>
                            MotionSpace BV ("we," "us," "our") values your privacy and is committed to protecting your
                            personal data. This Privacy Statement explains how we collect, use, and safeguard information
                            on our website.
                        </p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Contact Information</h2>
                        <p>
                            If you have any questions about this Privacy Statement or how we handle your data, you can reach us at:
                        </p>
                        <ul>
                            <li>Company Name: MotionSpace BV</li>
                            <li>Address: Madoerastraat 16, 2585 VB The Hague, The Netherlands</li>
                            <li>Email: <a href="mailto:rudi.geerdink@motionspace.io">rudi.geerdink@motionspace.io</a></li>
                            <li>Contact Person: Rudi Geerdink</li>
                        </ul>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Data We Collect</h2>
                        <p>
                            We collect personal information via our contact form. The data collected includes:
                        </p>
                        <ul>
                            <li>Name</li>
                            <li>Email Address</li>
                        </ul>
                        <p>
                            We use this information solely to respond to your inquiries and provide information about our services.
                        </p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Cookies and Analytics</h2>
                        <p>
                            Our website does not use cookies or similar tracking technologies. However, we use Google Analytics to understand
                            how visitors interact with our website. Google Analytics processes anonymous usage data. For more information,
                            refer to <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>.
                        </p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Data Sharing</h2>
                        <p>We do not share your personal data with third parties.</p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Data Retention</h2>
                        <p>
                            We retain your personal data for up to 1 year after collection, unless a longer retention period is required by law or necessary
                            to resolve disputes.
                        </p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Your Rights</h2>
                        <p>Under GDPR, you have the following rights:</p>
                        <ul>
                            <li>Access your personal data</li>
                            <li>Rectify inaccurate or incomplete data</li>
                            <li>Request data deletion</li>
                            <li>Object to or restrict processing of your data</li>
                            <li>Data portability</li>
                        </ul>
                        <p>
                            If you wish to exercise any of these rights, contact us at <a href="mailto:rudi.geerdink@motionspace.io">rudi.geerdink@motionspace.io</a>.
                            We will respond within 1 month of receiving your request.
                        </p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Data Security</h2>
                        <p>
                            We implement standard security measures to protect your data from unauthorized access, disclosure, alteration, or destruction.
                        </p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Updates to this Privacy Statement</h2>
                        <p>
                            We may update this Privacy Statement from time to time. Changes will be announced via a statement on this website.
                        </p>
                    </section>
                    <section className="privacy-policy-section">
                        <h2 className="privacy-policy-subheading">Legal Compliance</h2>
                        <p>We adhere to applicable privacy laws, including the General Data Protection Regulation (GDPR).</p>
                    </section>
                </div>
            </Section>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
